import {
  RANK_RANK_APPS_REQUEST,
  OTHER_RANK_APPS_REQUEST,
  RANK_RANKS_REQUEST,
} from '../constants/topn';

export const getRankApps = param => ({
  type: RANK_RANK_APPS_REQUEST,
  ...param,
});

export const getOtherRankApps = param => ({
  type: OTHER_RANK_APPS_REQUEST,
  ...param,
});

export const getAllRanksAndApps = () => ({
  type: RANK_RANKS_REQUEST,
});
